import { refreshAccessToken, logoutUser } from '../repository/authRepository';

interface RequestOptions extends RequestInit {
  retryCount?: number;
}

const MAX_RETRIES = 1;

export const fetchWithAuth = async (url: string, options: RequestOptions = {}): Promise<Response> => {
  let accessToken = localStorage.getItem('access_token');
  let refreshToken = localStorage.getItem('refresh_token');

  options.headers = {
    ...options.headers,
    'Content-Type': 'application/json',
  };

  if (accessToken) {
    options.headers = {
      ...options.headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  let response = await fetch(url, options);

  // If unauthorized and we have a refresh token, try to refresh
  if (response.status === 401 && refreshToken && (options.retryCount || 0) < MAX_RETRIES) {
    try {
      const newAccessToken = await refreshAccessToken(refreshToken);
      localStorage.setItem('access_token', newAccessToken);

      // Retry the original request with the new token
      options.headers = {
        ...options.headers,
        Authorization: `Bearer ${newAccessToken}`,
      };
      options.retryCount = (options.retryCount || 0) + 1;
      response = await fetchWithAuth(url, options); // Recursive call with new token
    } catch (refreshError) {
      console.error('Token refresh failed:', refreshError);
      logoutUser(); // Clear tokens and force re-login
      window.location.href = '/login'; // Redirect to login
      throw new Error('Session expired. Please log in again.');
    }
  } else if (response.status === 401 && (!refreshToken || (options.retryCount || 0) >= MAX_RETRIES)) {
    // If unauthorized and no refresh token, or max retries reached,
    // clear tokens and redirect to login
    logoutUser();
    window.location.href = '/login';
    throw new Error('Session expired. Please log in again.');
  }

  return response;
};

// Function to set up automatic token refresh (e.g., call after successful login)
export const setupAutoRefresh = () => {
  // This is a basic example. In a real app, you might use a setInterval
  // to proactively refresh the token before it expires.
  // For now, refresh happens reactively on 401.
  console.log("Automatic token refresh is set up to reactively refresh on 401.");
};
